/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AutoCompleteType,
    AutoCompleteTypeFromJSON,
    AutoCompleteTypeFromJSONTyped,
    AutoCompleteTypeToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutoCompleteFilter
 */
export interface AutoCompleteFilter {
    /**
     * 
     * @type {boolean}
     * @memberof AutoCompleteFilter
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AutoCompleteFilter
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof AutoCompleteFilter
     */
    term?: string | null;
    /**
     * 
     * @type {AutoCompleteType}
     * @memberof AutoCompleteFilter
     */
    type?: AutoCompleteType;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AutoCompleteFilter
     */
    filterType?: GuidIdCodeAndLabel;
}

export function AutoCompleteFilterFromJSON(json: any): AutoCompleteFilter {
    return AutoCompleteFilterFromJSONTyped(json, false);
}

export function AutoCompleteFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoCompleteFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'term': !exists(json, 'term') ? undefined : json['term'],
        'type': !exists(json, 'type') ? undefined : AutoCompleteTypeFromJSON(json['type']),
        'filterType': !exists(json, 'filterType') ? undefined : GuidIdCodeAndLabelFromJSON(json['filterType']),
    };
}

export function AutoCompleteFilterToJSON(value?: AutoCompleteFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showNonEffective': value.showNonEffective,
        'limit': value.limit,
        'term': value.term,
        'type': AutoCompleteTypeToJSON(value.type),
        'filterType': GuidIdCodeAndLabelToJSON(value.filterType),
    };
}


